module.exports = __webpack_public_path__ + "img/pluto168.d084497b.jpg";